// src/utils/mock.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { onProduction } from 'utils/helpers';
import useZustand from 'hooks/useZustand';

// *******************************************************************************
// METHODS
// *******************************************************************************
export const buildInitialValues = (isMock, data) => {
  // Check if mock mode is enabled
  const isMockEnabled =
    ((typeof isMock === 'number' && isMock >= 0) || (typeof isMock === 'boolean' && isMock)) &&
    !onProduction();

  if (!isMockEnabled) return {};

  // If data is provided, use it directly (preferred)
  if (data) return data;

  // Fallback: try to get mock from store (only works after store is populated)
  const storedCurrentPage = useZustand('module', 'currentPage', false);
  return storedCurrentPage?.mock || {};
};
